import React from "react";
import { Link } from "react-router";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Row,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import TableWrapper from "@/utils/TableWrapper";
import type { TableWrapperProps } from "@/utils/TableWrapper";

export type DisplayAdsViewProps<TData> = Pick<
  TableWrapperProps<TData>,
  "data" | "columns"
>;

export default function DisplayAdsView<TData>({
  data,
  columns,
}: DisplayAdsViewProps<TData>) {
  return (
    <>
      <SimpleHeader name="Display Ads" parentName="Product" />
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h3 className="mb-0">Manage Ads</h3>
              </CardHeader>
              <CardBody>
                <Row className="ml-3">
                  <FormGroup className="row">
                    <Button color="primary" size="sm" tag={Link} to="/admin/ads">
                      Add New
                    </Button>
                  </FormGroup>
                </Row>
                <TableWrapper data={data} columns={columns} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
